var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0288D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70361 12.5426H11.1604V24.2957H7.70361V12.5426ZM9.42164 11.1599H9.40228C8.37077 11.1599 7.70361 10.3911 7.70361 9.43083C7.70361 8.44979 8.39151 7.70312 9.44169 7.70312C10.4932 7.70312 11.141 8.44979 11.1604 9.43083C11.1604 10.3904 10.4932 11.1599 9.42164 11.1599ZM24.2962 24.2957H20.8394V18.005C20.8394 16.4854 19.9925 15.4484 18.6326 15.4484C17.5949 15.4484 17.0335 16.1481 16.7611 16.8242C16.6615 17.0662 16.6913 17.7354 16.6913 18.0735V24.2957H13.2345V12.5426H16.6913V14.3512C17.1897 13.5797 17.9703 12.5426 19.9669 12.5426C22.4406 12.5426 24.2955 14.0982 24.2955 17.5716L24.2962 24.2957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.f7d3f0affdde1c0fc909f756a0f4be3a.svg";
export { ForwardRef as ReactComponent };